<template>
  <div>
    <!-- {{selected_views}} -->
    <template v-if="isLoading === false">
      <!-- 未發布顯示的區塊-->
      <template v-if="!isRelease">
        <v-row>
          <v-col cols="12">
            <v-card>
              <div class="d-flex justify-center">
                <v-icon class="icon" color="warning"> mdi-note-edit-outline </v-icon>
              </div>
              <v-card-title style="justify-content: center">目前沒有報表資料。</v-card-title>
              <v-card-text class="text">
                <p
                  v-if="new Date(timer_picker.start_at.value) > new Date(timer_picker.end_at.value)"
                  v-text="`該實驗在開始前被手動終止，中止時間： ${parseDisplayTime(selectedExperience.end_at)}`"
                />
                <p v-else v-text="'您的實驗目前仍只是草稿。如要開始實驗，請按一下「詳情」頁面上的 [發布實驗]。'" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-if="isRelease">
        <v-row
          v-if="
            (selectedExperience.enable === true && selectedExperience.release) ||
            (selectedExperience.enable === false && selectedExperience.release)
          "
          class="pb-0 mb-3"
        >
          <v-col cols="12" class="pb-0">
            <v-card
              class="mt-0 pt-2 pb-0 pl-0 white--text"
              :class="{
                release:
                  selectedExperience.enable &&
                  selectedExperience.release &&
                  new Date().getTime() < new Date(selectedExperience.end_at).getTime(),
                end:
                  selectedExperience.enable === false ||
                  new Date().getTime() > new Date(selectedExperience.end_at).getTime(),
              }"
            >
              <v-card-title class="pl-3 pt-0 pb-2 text-subtile2">
                <template
                  v-if="
                    selectedExperience.release === true &&
                    selectedExperience.enable === true &&
                    new Date().getTime() < new Date(selectedExperience.end_at).getTime()
                  "
                >
                  <div>
                    <v-icon color="white" class="mr-3"> mdi-timer-outline </v-icon>
                    <span>執行中</span>
                  </div>
                </template>

                <template v-else>
                  <div>
                    <v-icon color="white" class="mr-3"> mdi-check-circle-outline </v-icon>
                    <span>已結束</span>
                  </div>
                </template>

                <v-spacer></v-spacer>

                <template
                  v-if="
                    selectedExperience.release === true &&
                    selectedExperience.enable === true &&
                    new Date().getTime() < new Date(selectedExperience.end_at).getTime()
                  "
                >
                  <v-btn class="release--text" @click="stopExperiment">
                    <v-icon left color="release"> mdi-stop-circle-outline </v-icon>
                    結束實驗
                  </v-btn>
                </template>
              </v-card-title>
              <v-card-text
                class="pt-1 pb-1 pl-4 pr-0 text-subtitle-1 d-flex white--text"
                :class="{
                  'green darken-2':
                    selectedExperience.enable &&
                    selectedExperience.release &&
                    new Date().getTime() < new Date(selectedExperience.end_at).getTime(),
                  'grey darken-2':
                    selectedExperience.enable === false ||
                    new Date().getTime() > new Date(selectedExperience.end_at).getTime(),
                }"
              >
                <v-row>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    <p class="pb-0 mb-0">{{ `開始: ${parseDisplayTime(selectedExperience.start_at)}` }}</p>
                  </v-col>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    <p class="pb-0 mb-0">{{ `結束: ${parseDisplayTime(selectedExperience.end_at)}` }}</p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mt-0 pt-0 mb-1">
          <v-col cols="12" md="12" sm="12" lg="12">
            <v-card elevation="0" tile class="d-flex justify-end flex-column align-end">
              <v-card
                elevation="0"
                tile
                class="d-flex align-center"
                :height="'30px'"
                style="max-width: 20em; width: 100%"
              >
                <v-menu
                  v-model="timer_picker['start_at'].is_open"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  :nudge-right="-100"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="timer_picker['start_at'].value"
                      label="開始時間"
                      readonly
                      v-bind="attrs"
                      dense
                      hide-details
                      class="date-picker"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="timer_picker['start_at'].value"
                    :min="selectedExperience.start_at.split(' ')[0]"
                    :max="selectedExperience.end_at.split(' ')[0]"
                    locale="zh-tw"
                    @change="checkDate"
                    @input="timer_picker['start_at'].is_open = false"
                  ></v-date-picker>
                </v-menu>

                <span class="ml-3 mr-3"> - </span>

                <v-menu
                  v-model="timer_picker['end_at'].is_open"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  :nudge-right="-150"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="timer_picker['end_at'].value"
                      class="date-picker"
                      label="結束時間"
                      readonly
                      v-bind="attrs"
                      dense
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="timer_picker['end_at'].value"
                    :min="selectedExperience.start_at.split(' ')[0]"
                    :max="selectedExperience.end_at.split(' ')[0]"
                    locale="zh-tw"
                    @change="checkDate"
                    @input="timer_picker['end_at'].is_open = false"
                  ></v-date-picker>
                </v-menu>
              </v-card>
              <p class="time-picker-error-msg mt-1 mb-0">{{ timer_picker.error_msg }}</p>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mt-0 pt-0">
          <v-col class="mt-0 pt-0" cols="12">
            <v-card class="pt-2 mb-3">
              <v-card-title class="pt-0 pb-0">
                <v-spacer></v-spacer>
                <v-btn icon @click="goGoogleAnalytics">
                  <v-icon color="#faaa00"> mdi-google-analytics </v-icon>
                </v-btn>
              </v-card-title>
              <!-- {{ drag_items }} -->
              <v-data-table
                :loading="table_loading"
                :loading-text="'載入資料中'"
                :no-data-text="'無資料'"
                :headers="category_table_header[selected_category.value]"
                :items="category_table_item[selected_category.value]"
                hide-default-footer
                :sort-by="'sort_key'"
                :items-per-page="category_table_item[selected_category.value].length"
              >
                <template
                  v-for="h in category_table_header[selected_category.value]"
                  #[`header.${h.value}`]="{ header }"
                >
                  <v-tooltip v-if="h.hint !== ''" :key="h.value" bottom>
                    <template #activator="{ on }">
                      <p class="ma-0 pa-0 d-inline-flex align-center">
                        <span v-on="on">{{ header.text }}</span>
                        <v-icon color="primary" small v-on="on" @click="goQA(header.link_poniter)">
                          mdi-help-circle
                        </v-icon>
                      </p>
                    </template>
                    <span>{{ h.hint }}</span>
                  </v-tooltip>
                  <p v-else :key="h.value" class="ma-0 pa-0 d-inline-flex align-center">{{ header.text }}</p>
                </template>
                <template #top>
                  <v-toolbar flat>
                    <v-spacer></v-spacer>

                    <v-btn color="grey" dark class="mb-2 mr-3" @click="resetGroup"> 全部復原 </v-btn>

                    <v-btn
                      v-if="selected_views.length > 0"
                      color="purple"
                      dark
                      class="mb-2 mr-3"
                      @click="selected_views = []"
                    >
                      取消勾選
                    </v-btn>

                    <template v-if="selected_views.length <= 0">
                      <v-btn color="primary" dark class="mb-2" @click="saveGroup"> 保存結果 </v-btn>
                    </template>
                    <template v-else>
                      <v-btn color="warning" dark class="mb-2 mr-3" @click="unMergeRow"> 解除合併 </v-btn>

                      <v-btn color="primary" dark class="mb-2" @click="createGroup"> 合併群組 </v-btn>
                    </template>
                  </v-toolbar>
                </template>

                <template #body="">
                  <draggable :list="drag_items" tag="tbody" :move="onMove" handle=".drag-handle" @end="onDragEnd">
                    <template v-for="item in drag_items">
                      <tr
                        v-if="(item.childs && item.childs.length > 0) || item.is_open === undefined || item.is_open"
                        :key="item.id"
                        :class="{
                          'parent-row': item.childs && item.childs.length > 0,
                        }"
                      >
                        <td>
                          <div
                            class="d-flex align-center"
                            :class="{
                              'sub-row': item.parent,
                            }"
                          >
                            <v-icon
                              v-if="item.childs && item.childs.length > 0 && item.is_open === true"
                              @click="activateSub(item, false)"
                            >
                              mdi-chevron-down
                            </v-icon>
                            <v-icon
                              v-if="item.childs && item.childs.length > 0 && item.is_open === false"
                              @click="activateSub(item, true)"
                            >
                              mdi-chevron-up
                            </v-icon>
                            <v-checkbox v-model="selected_views" class="pt-0" hide-details dense :value="item.id">
                            </v-checkbox>

                            <v-icon small class="drag-handle"> mdi-arrow-all </v-icon>
                          </div>
                        </td>
                        <td>
                          <section class="d-flex align-center justify-space-between">
                            <div>
                              {{ item.name }}
                            </div>
                            <div class="d-flex">
                              <v-icon
                                v-if="item.id && !item.id.includes('parent')"
                                dense
                                class="ml-2"
                                @click="previewVersion(item)"
                              >
                                mdi-open-in-new
                              </v-icon>

                              <v-icon
                                v-if="
                                  vid_data_mapper[item.id] &&
                                  vid_data_mapper[item.id].img_url &&
                                  !item.id.includes('parent')
                                "
                                dense
                                class="ml-2"
                                @click="showScreenshot(vid_data_mapper[item.id].img_url)"
                              >
                                mdi-image
                              </v-icon>

                              <v-icon
                                v-if="item.id && !item.id.includes('parent')"
                                dense
                                class="ml-2"
                                @click="viewOrders(item)"
                              >
                                mdi-clipboard-text-outline
                              </v-icon>
                            </div>
                          </section>
                        </td>
                        <td class="text-right no-break-line">
                          {{
                            ` ${$utils.formatNumberWithCommas(
                              calculateSum(item, item.childs, 'session')
                            )} / ${$utils.formatNumberWithCommas(calculateSum(item, item.childs, 'dup_session'))}`
                          }}
                        </td>
                        <td
                          class="text-right"
                          :class="{
                            'limit-up': item.bounce_rate_is_best === true,
                          }"
                        >
                          {{ calculateRateSum(item, item.childs, 'bounce_rate') }}
                          <span v-if="item.bounce_rate_is_best">👍</span>
                        </td>

                        <td class="text-right no-break-line">
                          {{
                            ` ${$utils.formatNumberWithCommas(
                              calculateSum(item, item.childs, 'cart')
                            )} / ${$utils.formatNumberWithCommas(calculateSum(item, item.childs, 'dup_cart'))}`
                          }}
                        </td>

                        <td
                          class="text-right no-break-line"
                          :class="{
                            'limit-up': item.cart_rate_is_best === true,
                          }"
                        >
                          {{
                            `${calculateRateSum(item, item.childs, 'cart_rate')} / ${calculateRateSum(
                              item,
                              item.childs,
                              'dup_cart_rate'
                            )}`
                          }}
                          <span v-if="item.cart_rate_is_best">👍</span>
                        </td>

                        <td>
                          <section class="d-flex align-center justify-end">
                            <span>
                              {{ ` ${$utils.formatNumberWithCommas(calculateSum(item, item.childs, 'transaction'))}` }}
                            </span>
                          </section>
                        </td>

                        <td
                          class="text-right no-break-line"
                          :class="{
                            'limit-up': item.transaction_rate_is_best === true,
                          }"
                        >
                          {{ calculateRateSum(item, item.childs, 'transaction_rate') }}
                          <span v-if="item.transaction_rate_is_best">👍</span>
                        </td>

                        <td class="text-right">
                          {{ ` ${$utils.formatNumberWithCommas(calculateSum(item, item.childs, 'values'))}` }}
                        </td>

                        <td class="text-right">
                          {{ $utils.formatNumberWithCommas(calculateSum(item, item.childs, 'values_rate')) }}
                        </td>
                      </tr>
                    </template>

                    <tr style="font-weight: bold">
                      <td></td>
                      <td>{{ total_row.name }}</td>
                      <td class="text-right no-break-line">{{ `${total_row.session} / ${total_row.dup_session}` }}</td>
                      <td class="text-right no-break-line">{{ `${total_row.bounce_rate}` }}</td>
                      <td class="text-right no-break-line">{{ `${total_row.cart} / ${total_row.dup_cart}` }}</td>
                      <td class="text-right no-break-line">
                        {{ `${total_row.cart_rate} / ${total_row.dup_cart_rate}` }}
                      </td>
                      <td class="text-right no-break-line">{{ total_row.transaction }}</td>
                      <td class="text-right no-break-line">{{ total_row.transaction_rate }}</td>
                      <td class="text-right no-break-line">{{ total_row.values }}</td>
                      <td class="text-right no-break-line">{{ total_row.values_rate }}</td>
                    </tr>
                  </draggable>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mt-0 pt-0">
          <v-col class="mt-0 pt-0">
            <v-card>
              <v-card-title>
                分析報表

                <v-spacer></v-spacer>

                <v-btn-toggle v-model="selected_day_unit" mandatory @change="renderChart(category_data_mapper)">
                  <v-btn small> 日 </v-btn>
                  <v-btn small> 週 </v-btn>
                  <v-btn small> 月 </v-btn>
                </v-btn-toggle>
              </v-card-title>

              <v-card-text class="d-flex">
                <p class="mr-3 d-flex align-center">
                  <span class="mr-4">指標一: </span>
                  <v-select
                    v-model="selected_goal_1"
                    class="goal-selector"
                    outlined
                    :items="goal_1"
                    dense
                    hide-details
                    return-object
                    @change="renderChart(category_data_mapper)"
                  >
                  </v-select>
                </p>
                <p v-if="false" class="d-flex align-center">
                  <span class="mr-4">指標二: </span>
                  <v-select
                    v-model="selected_goal_2"
                    class="goal-selector"
                    outlined
                    :items="goal_2"
                    dense
                    hide-details
                    return-object
                    @change="renderChart(category_data_mapper)"
                  >
                  </v-select>
                </p>
              </v-card-text>

              <!-- <v-card-subtitle style="padding: 20px 20px; margin-top: 20px; color: rgba(0,0,0); font-size: 15px;">
                                {{ selected_category.text }}
                            </v-card-subtitle> -->

              <div ref="dashboard" class="d-flex">
                <LineChartGenerator
                  ref="lineChart"
                  :key="table_render_key"
                  :chart-options="chartOptions"
                  :chart-data="category_chartdata"
                  style="width: 100%"
                />
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </template>

    <v-dialog v-model="order_dialog.is_show" width="900" @click:outside="hideOrderDialog">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> 訂單號碼 </v-card-title>

        <v-card-text class="pl-2 pr-2 mt-3 mb-3">
          <v-row>
            <v-col cols="12" md="7">
              <v-text-field
                v-model="order_dialog.keyword"
                outlined
                dense
                class="ml-0 pt-0 mb-3"
                placeholder="搜尋 訂單編號，多筆以逗號,分隔 例如:123,456"
                append-icon="mdi-magnify"
                hide-details
                @click:append="search"
                @keyup.enter="search"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="5">
              <v-card-title class="d-flex pa-0 justify-end mb-5">
                <v-row>
                  <v-col cols="12" md="">
                    <v-select
                      v-model="order_dialog.selected_start_at_item"
                      dense
                      outlined
                      :items="order_dialog.start_at_items"
                      item-value="value"
                      item-text="text"
                      hide-details
                      label="開始時間"
                      @change="search"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="order_dialog.selected_end_at_item"
                      dense
                      outlined
                      :items="order_dialog.end_at_items"
                      item-value="value"
                      item-text="text"
                      hide-details
                      label="結束時間"
                      @change="search"
                    >
                    </v-select>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-col>
          </v-row>
          <v-card>
            <v-data-table
              height="50vh"
              fixed-header
              :headers="order_dialog.headers"
              :items="order_dialog.items"
              hide-default-footer
              :items-per-page="order_dialog.items.length"
              sort-by="event_date"
            >
            </v-data-table>
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="hideOrderDialog"> 關閉 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="hint_dialog.is_show" width="450" @click:outside="hideHintDialog">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2 pl-2">
          {{ hint_dialog.title }}
        </v-card-title>

        <v-card-text class="pl-2 pr-2 mt-3 mb-3 pb-0">
          <div v-html="hint_dialog.html"></div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="hideHintDialog"> 關閉 </v-btn>
          <v-btn color="primary" text @click="hintAction(hint_dialog.action_method_params)">
            {{ hint_dialog.action_text }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <LoadingOverlay v-if="isLoading" :is-loading="isLoading" />

    <DialogInput
      v-if="group_setting.is_show"
      :setting="group_setting"
      @submit="getGroupName"
      @cancel="cancelCreateGroup"
      @outside="cancelCreateGroup"
    >
    </DialogInput>
  </div>
</template>

<script>
import DialogInput from '@/components/Dialogs/DialogInput.vue'
import draggable from 'vuedraggable'
// import nestedDraggable from "@/components/Utils/Netsted.vue";
import { apiGetPreviewTokenWithData, apiPatchExperienceDisable, apiRenameExp } from '@/api/optimize.js'

// import Vuex Helper
import { mapGetters } from 'vuex'

import { apiGetAnalysisReport, apiGetAnalysisReportBounce } from '@/api/analysis.js'

import LoadingOverlay from '@/components/Utils/LoadingOverlay.vue'

import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from 'chart.js'

const pulsingPointPlugin = {
  id: 'pulsingPoint',
  beforeDatasetsDraw(chart, args, pluginOptions) {
    if (pluginOptions?.enabled === false) return

    const ctx = chart.ctx
    const now = Date.now()
    const scale = 1 + 0.5 * Math.sin(now / 150)

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex)
      if (!meta || !meta.data || meta.data.length === 0) return
      const lastIndex = meta.data.length - 1
      const plugin_params = JSON.parse(JSON.stringify(pluginOptions))
      const now_view = plugin_params.vid_data_mapper[dataset.vid]
      if (now_view && parseInt(now_view.priority) <= 0) {
        // console.log(`${dataset.label} 不應該畫`, priority)
        return
      }

      const point = meta.data[lastIndex]
      const { x, y } = point.getProps(['x', 'y'], true)

      ctx.save()
      ctx.translate(x, y)
      ctx.scale(scale, scale)
      ctx.beginPath()
      ctx.arc(0, 0, 5, 0, 2 * Math.PI)
      ctx.fillStyle = dataset.borderColor
      ctx.fill()
      ctx.restore()
    })
  },
}

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement, pulsingPointPlugin)

export default {
  name: 'Report',
  components: {
    LoadingOverlay,
    LineChartGenerator,
    draggable,
    DialogInput,
  },
  props: {
    items: Array,
    selectedExperience: Object,
  },
  data() {
    return {
      order_event_ids: [],
      analysis_datas: [],
      selected_category: { text: '總覽', value: 'All' },
      category_data_mapper: {},
      categorys_items: [
        {
          text: '總覽',
          value: 'All',
        },
        {
          text: '加入購物車',
          value: 'AddToCart',
        },
        {
          text: '成交次數',
          value: 'PlaceAnOrder',
        },
      ],
      vid_name_mapper: {},
      vid_data_mapper: {},
      vid_colors: [
        '#E57373', // 红色
        '#FFB74D', // 橙色
        '#FFF176', // 黄色
        '#81C784', // 绿色
        '#64B5F6', // 蓝色
        '#4FC3F7', // 靛蓝
        '#9575CD', // 紫色
        '#B0BEC5', // 灰色
        '#F06292', // 粉红色
        '#A1887F', // 棕色
        '#90A4AE', // 蓝灰色
        '#CE93D8', // 浅紫色
        '#80DEEA', // 青绿色
        '#AED581', // 浅绿色
        '#FF8A65', // 桃红色
        '#FFB300', // 金色
        '#64FFDA', // 薄荷绿
        '#FF5252', // 深红色
        '#FFC107', // 深黄色
        '#69F0AE', // 淡绿色
        '#448AFF', // 深蓝色
      ],
      total_view_session: 0,
      info_url: 'https://www.optimize99.com/pages/qa',
      category_table_header: {
        All: [
          // { text: '版本', value: 'sort_key', sortable: false, hint: ''},
          { text: '', value: 'actions', sortable: false, hint: '' },
          { text: '版本', value: 'name', sortable: false, hint: '' },
          {
            text: '工作階段',
            value: 'session',
            sortable: true,
            hint: '以使用者為計算單位(不重複/重複)，點我查看計算方式',
            link_poniter: '#title01',
          },
          {
            text: '跳出率',
            value: 'bounce_rate',
            sortable: false,
            hint: '使用者進入網頁後，沒有在查看其他頁面直接離開',
            link_poniter: '',
          },
          {
            text: '加入購物車數',
            value: 'cart',
            sortable: true,
            hint: '以使用者為計算單位(不重複/重複)，點我查看計算方式',
            link_poniter: '#title02',
          },
          {
            text: '加入購物車率',
            value: 'cart_rate',
            sortable: true,
            hint: '加入購物車數 / 工作階段(不重複/重複)，點我查看計算方式',
            link_poniter: '#title03',
          },
          {
            text: '下單數',
            value: 'transaction',
            sortable: true,
            hint: '下單數，點我查看計算方式',
            link_poniter: '#title04',
          },
          {
            text: '下單率',
            value: 'transaction_rate',
            sortable: true,
            hint: '下單數 / 工作階段，點我查看計算方式',
            link_poniter: '#title05',
          },
          {
            text: '營業額',
            value: 'values',
            sortable: true,
            hint: '營業額，點我查看計算方式',
            link_poniter: '#title06',
          },
          {
            text: '客單價',
            value: 'values_rate',
            sortable: true,
            hint: '營業額 / 下單數，點我查看計算方式',
            link_poniter: '#title07',
          },
        ],
        PlaceAnOrder: [
          { text: '變化版本名稱', value: 'name', sortable: false, hint: '' },
          { text: '實驗工作階段', value: 'session', sortable: true, hint: '' },
          { text: '成交單數', value: 'event', sortable: true, hint: '' },
          {
            text: '計算得出的電子商務轉換率',
            value: 'rate',
            sortable: true,
            hint: '實驗成交 / 實驗工作階段 得到的百分比。',
          },
        ],
        AddToCart: [
          { text: '變化版本名稱', value: 'name', sortable: false, hint: '' },
          { text: '實驗工作階段', value: 'session', sortable: true, hint: '' },
          { text: '加入購物車數', value: 'event', sortable: true, hint: '' },
          { text: '加入購物車率', value: 'rate', sortable: true, hint: '加入購物車數 / 實驗工作階段 得到的百分比。' },
        ],
      },
      category_table_item: {},
      total_row: {},
      fix_dot: 2,
      category_chartdata: {
        // labels: [],
        // datasets: []
      },
      chartOptions: {
        interaction: {
          mode: 'index',
          intersect: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: false,
            position: 'left',
            min: 0,
            ticks: {
              stepSize: 1, // 设置刻度间距为 1
              beginAtZero: true, // 从零开始
            },
          },
          y1: {
            stacked: false,
            position: 'right',
            min: 0,
            ticks: {
              min: 0,
              stepSize: 1, // 设置刻度间距为 1
              beginAtZero: true, // 从零开始
            },
          },
        },
        animation: false,
        plugins: {
          legend: {
            labels: {
              usePointStyle: true,
              // 使用回调函数自定义图例项的样式
              generateLabels: function (chart) {
                return chart.data.datasets.map(function (dataset, datasetIndex) {
                  var pointStyle = 'rect' // 默认样式

                  // 根据数据集的 label 进行条件判断，自定义图例项的样式
                  if (dataset.type === 'line') {
                    pointStyle = 'line' // 将 Data 1 的样式设为线条
                  }

                  return {
                    datasetIndex: datasetIndex,
                    text: dataset.label,
                    fillStyle: dataset.backgroundColor,
                    strokeStyle: dataset.borderColor,
                    lineWidth: dataset.borderWidth,
                    pointStyle: pointStyle,
                  }
                })
              },
            },
          },
          pulsingPoint: {
            enabled: false,
          },
        },
      },
      timer_picker: {
        start_at: {
          is_open: false,
          value: null,
        },
        end_at: {
          is_open: false,
          value: null,
        },
        error_msg: '',
      },
      selected_day_unit: 0,
      selected_goal_1: {
        text: '工作階段',
        value: 'View',
      },
      goal_1: [
        // {
        //     "text": "無",
        //     "value": "None"
        // },
        {
          text: '工作階段',
          value: 'View',
        },
        {
          text: '加入購物車數',
          value: 'AddToCart',
        },
        // {
        //     "text": "加入購物車率",
        //     "value": "AddToCartRate"
        // },
        {
          text: '下單數',
          value: 'Transaction',
        },
        // {
        //     "text": "下單率",
        //     "value": "TransactionRate"
        // },
        {
          text: '營業額',
          value: 'Value',
        },
        // {
        //     "text": "下單率",
        //     "value": "ValuesRate"
        // },
      ],
      selected_goal_2: {
        text: '無',
        value: 'None',
      },
      goal_2: [
        {
          text: '無',
          value: 'None',
        },
        {
          text: '工作階段',
          value: 'View',
        },
        {
          text: '加入購物車數',
          value: 'AddToCart',
        },
        // {
        //     "text": "加入購物車率",
        //     "value": "AddToCartRate"
        // },
        {
          text: '下單數',
          value: 'Transaction',
        },
        // {
        //     "text": "下單率",
        //     "value": "TransactionRate"
        // },
        {
          text: '營業額',
          value: 'Value',
        },
        // {
        //     "text": "下單率",
        //     "value": "ValuesRate"
        // },
      ],
      table_render_key: 0,
      order_dialog: {
        selected_start_at_item: null,
        start_at_items: [],
        selected_end_at_item: null,
        end_at_items: [],
        view: null,
        keyword: '',
        is_show: false,
        headers: [
          { text: '日期', value: 'event_date', sortable: true, hint: '' },
          { text: '訂單編號', value: 'order_id', sortable: true, hint: '' },
          { text: '商品數量', value: 'quantity', sortable: true, hint: '' },
          { text: '金額', value: 'value', sortable: true, hint: '' },
        ],
        items: [],
      },
      hint_dialog: {
        is_show: false,
        title: '',
        html: '',
        action_text: '',
        action_method_params: {},
      },

      sliderDateRange: [0, 10],
      ticksLabels: [],
      tickSize: 0,
      maxRange: 0,

      isLoading: true,
      goal: '成交次數',
      headers: [
        { text: '變化版本名稱', value: 'name', sortable: false },
        { text: '實驗工作階段', value: 'session', sortable: false },
        { text: '實驗成交', value: 'orders', sortable: false },
        { text: '計算得出的電子商務轉換率', value: 'cvr', sortable: false },
      ],
      local_items: this.items,
      principal: true,
      analytical_item: [
        {
          title: '成交次數',
          key: 'PlaceAnOrder',
        },
        {
          title: '加入購物車',
          key: 'AddToCart',
        },
        {
          title: '網頁瀏覽',
          key: 'View',
        },
      ],
      selectedCategories: null,

      views_analysis_item: null,

      analysisEventKeyMapper: {
        加入購物車: 'AddToCart',
        成交次數: 'PlaceAnOrder',
        網頁瀏覽: 'View',
      },

      start_at: '',
      end_at: '',
      originalLabels: null,
      table_loading: false,
      selected_views: [],
      table_key: 0,
      group_setting: {
        title: '建立群組',
        is_show: false,
        width: 450,
        fields: [
          {
            name: '群組名稱',
            value: '',
            is_required: false,
            key: 'name',
          },
        ],
        submit_text: '確定',
        cancel_text: '取消',
        submit_event: 'submit',
        cancel_event: 'cancel',
      },
      drag_items: [],
    }
  },
  computed: {
    ...mapGetters(['selectedContainer', 'organize_container_mapper']),
    isRelease() {
      return this.selectedExperience.release && Object.keys(this.category_table_item).length > 0
    },
  },
  watch: {
    selected_goal_1: function (new_val, old_val) {
      console.log('new_val', new_val)
      console.log('old_val', old_val)
      this.goal_2 = this.goal_2.map(function (goal) {
        if (goal.value === new_val.value) {
          goal.disabled = true
        } else {
          goal.disabled = false
        }
        return goal
      })
    },
    selected_goal_2: function (new_val, old_val) {
      console.log('new_val', new_val)
      console.log('old_val', old_val)
      this.goal_1 = this.goal_1.map(function (goal) {
        if (goal.value === new_val.value) {
          goal.disabled = true
        } else {
          goal.disabled = false
        }
        return goal
      })
      console.log('this.goal_1', this.goal_1)
    },
    drag_items(new_items, old_items) {
      console.log('drag_items_new', new_items)
      console.log('drag_items_old', old_items)
      let rate_keys = ['bounce_rate', 'cart_rate', 'transaction_rate']
      new_items.forEach((new_item) => {
        rate_keys.forEach((rate_key) => {
          new_item[`${rate_key}_is_best`] = null
        })
      })
      // 可以比的row: parent
      let active_and_parent_rows = new_items.filter((new_item) => {
        // console.log('QQQQ', new_item.dup_session !== 0 && (new_item.id.includes('parent') || !new_item.parent))
        return new_item.dup_session != 0 && (new_item.id.includes('parent') || !new_item.parent)
      })
      console.log('active_and_parent_rows_1', active_and_parent_rows)
      if (active_and_parent_rows.length <= 0) {
        return
      }

      active_and_parent_rows.forEach((active_and_parent_row) => {
        if (active_and_parent_row.id.includes('parent')) {
          rate_keys.forEach((rate_key) => {
            active_and_parent_row[`${rate_key}_tmp`] = this.calculateRateSum(
              active_and_parent_row,
              active_and_parent_row.childs,
              rate_key
            )
          })
        }
      })
      let best_bounce_rate_row = active_and_parent_rows.reduce((min, item) => {
        // 優先使用 cart_rate_tmp，如果沒有才用 cart_rate
        const rateStr = item.bounce_rate_tmp || item.bounce_rate || '0%'
        const rate = parseFloat(rateStr)

        const minRateStr = min.bounce_rate_tmp || min.bounce_rate || '0%'
        const minRate = parseFloat(minRateStr)

        return rate < minRate ? item : min
      })

      if (best_bounce_rate_row.bounce_rate !== '0%' && active_and_parent_rows.length > 1) {
        best_bounce_rate_row.bounce_rate_is_best = true
      }
      console.log('best_bounce_rate_row', best_bounce_rate_row)

      let best_cart_rate_row = active_and_parent_rows.reduce((max, item) => {
        // 優先使用 cart_rate_tmp，如果沒有才用 cart_rate
        const rateStr = item.cart_rate_tmp || item.cart_rate || '0%'
        const rate = parseFloat(rateStr)

        const maxRateStr = max.cart_rate_tmp || max.cart_rate || '0%'
        const maxRate = parseFloat(maxRateStr)

        return rate > maxRate ? item : max
      })

      if (best_cart_rate_row.cart_rate !== '0%' && active_and_parent_rows.length > 1) {
        best_cart_rate_row.cart_rate_is_best = true
      }
      let best_transaction_rate_row = active_and_parent_rows.reduce((max, item) => {
        // 優先使用 cart_rate_tmp，如果沒有才用 cart_rate
        const rateStr = item.transaction_rate_tmp || item.transaction_rate || '0%'
        const rate = parseFloat(rateStr)

        const maxRateStr = max.transaction_rate_tmp || max.transaction_rate || '0%'
        const maxRate = parseFloat(maxRateStr)

        return rate > maxRate ? item : max
      })

      if (best_transaction_rate_row.transaction_rate !== '0%' && active_and_parent_rows.length > 1) {
        best_transaction_rate_row.transaction_rate_is_best = true
      }
      console.log('best_bounce_rate_row', best_bounce_rate_row)
      console.log('best_cart_rate_row', best_cart_rate_row)
      console.log('best_transaction_rate_row', best_transaction_rate_row)
      console.log('active_and_parent_rows_2', active_and_parent_rows)
    },
  },
  async created() {
    try {
      let that = this
      this.isLoading = true

      // 右上角的時間
      let is_running = false
      if (
        this.selectedExperience.release === true &&
        this.selectedExperience.enable === true &&
        new Date().getTime() < new Date(this.selectedExperience.end_at).getTime()
      ) {
        is_running = true
      }

      // 如果還在執行中 就當下時間-14天
      if (is_running) {
        this.timer_picker.end_at.value = this.$utils.calculateDateOffset(0)
        this.timer_picker.start_at.value = this.$utils.calculateDateOffset(-14)
        if (
          new Date(this.timer_picker.start_at.value).getTime() <
          new Date(this.selectedExperience.start_at.split(' ')[0]).getTime()
        ) {
          this.timer_picker.start_at.value = this.selectedExperience.start_at.split(' ')[0]
          this.timer_picker.end_at.value = this.selectedExperience.end_at.split(' ')[0]
        }
        // this.timer_picker.start_at.value = this.$utils.calculateDateOffset(-14)
      }
      // 結束的話拿結束時間當日期
      else {
        this.timer_picker.end_at.value = this.selectedExperience.end_at.split(' ')[0]
        this.timer_picker.start_at.value = this.$utils.calculateDateOffset(-14, this.timer_picker.end_at.value)
        if (
          new Date(this.timer_picker.start_at.value).getTime() <
          new Date(this.selectedExperience.start_at.split(' ')[0]).getTime()
        ) {
          this.timer_picker.start_at.value = this.selectedExperience.start_at.split(' ')[0]
        }
      }

      // 建個vid對名字的mapper
      console.log('yo Report.vue', this.selectedExperience)
      console.log('local-items', this.local_items)
      // this.local_items = this.local_items.sort((a, b) => a.id - b.id);

      // 建立chart顏色
      let colors = this.createColors(this.local_items.length, '#3379ff', 30)
      console.log('colors', colors)
      this.local_items.forEach(function (item) {
        that.vid_name_mapper[item.vid] = item.name
        that.vid_data_mapper[item.vid] = item
      })
      console.log('vid_name_mapper', this.vid_name_mapper)
      console.log('vid_data_mapper', this.vid_data_mapper)
      await this.checkDate()

      this.goal_2 = this.goal_2.map(function (goal) {
        if (goal.value === that.selected_goal_1.value) {
          goal.disabled = true
        } else {
          goal.disabled = false
        }
        return goal
      })
    } catch (e) {
      console.log(e)
      this.$root.vtoast.show({ message: e.name + ': ' + e.message, color: 'error' })
    } finally {
      this.isLoading = false
    }
  },
  mounted() {},
  methods: {
    filterDisplayData: function (datas, start_at, end_at) {
      console.log('start_at', start_at)
      console.log('end_at', end_at)
      let target_start_at = new Date(start_at).getTime()
      let target_end_at = new Date(end_at).getTime()
      console.log('target_start_at', target_start_at)
      console.log('target_end_at', target_end_at)
      datas = datas.filter(function (data) {
        let event_at = new Date(data.event_date).getTime()
        return event_at >= target_start_at && event_at <= target_end_at
      })

      return datas
    },
    handleTableData: function (display_views, category_mapper) {
      let table_items = []
      let that = this
      display_views.forEach(function (display_view) {
        let view_data = {
          sort_key: display_view.sort_key,
          id: display_view.vid,
          name: that.vid_name_mapper[display_view.vid],
          session: 0,
          dup_session: 0,
          bounce_rate: '0.00%',
          cart: 0,
          dup_cart: 0,
          cart_rate: '0.00%',
          dup_cart_rate: '0.00%',
          transaction: 0,
          transaction_rate: 0,
          values_rate: '0.00%',
          values: 0,
        }
        if (category_mapper[display_view.vid]) {
          let session = that.calculateCategorySum('View', category_mapper, 'value_count', display_view.vid)
          let dup_session = that.calculateCategorySum('View', category_mapper, 'value_count_repeat', display_view.vid)
          let bounce_event = that.calculateCategorySum('BounceCount', category_mapper, 'value_count', display_view.vid)
          let cart = that.calculateCategorySum('AddToCart', category_mapper, 'value_count', display_view.vid)
          let dup_cart = that.calculateCategorySum('AddToCart', category_mapper, 'value_count_repeat', display_view.vid)
          console.log('bounce_event', bounce_event)
          let bounce_rate = ((bounce_event / session) * 100).toFixed(that.fix_dot)
          if (isNaN(bounce_rate)) {
            bounce_rate = '0%'
          } else {
            bounce_rate = '0%'
          }
          let cart_rate = ((cart / session) * 100).toFixed(that.fix_dot)
          if (isNaN(cart_rate)) {
            cart_rate = '0.00%'
          } else {
            cart_rate = cart_rate.toString() + '%'
          }
          let dup_cart_rate = ((dup_cart / dup_session) * 100).toFixed(that.fix_dot)
          if (isNaN(dup_cart_rate)) {
            dup_cart_rate = '0.00%'
          } else {
            dup_cart_rate = dup_cart_rate.toString() + '%'
          }
          let transaction = that.calculateCategorySum('PlaceAnOrder', category_mapper, 'value_count', display_view.vid)
          let transaction_rate = ((transaction / session) * 100).toFixed(that.fix_dot)
          if (isNaN(transaction_rate)) {
            transaction_rate = '0.00%'
          } else {
            transaction_rate = transaction_rate.toString() + '%'
          }
          let values = that.calculateCategorySum('PlaceAnOrder', category_mapper, 'value_sum', display_view.vid)
          let values_rate = (values / transaction).toFixed(that.fix_dot)
          if (isNaN(values_rate)) {
            values_rate = '0.00'
          } else {
            values_rate = values_rate.toString()
          }
          view_data['session'] = that.$utils.formatNumberWithCommas(session)
          view_data['dup_session'] = that.$utils.formatNumberWithCommas(dup_session)
          view_data['bounce_rate'] = that.$utils.formatNumberWithCommas(bounce_rate)
          view_data['cart'] = that.$utils.formatNumberWithCommas(cart)
          view_data['dup_cart'] = that.$utils.formatNumberWithCommas(dup_cart)
          view_data['cart_rate'] = that.$utils.formatNumberWithCommas(cart_rate)
          view_data['dup_cart_rate'] = that.$utils.formatNumberWithCommas(dup_cart_rate)
          view_data['transaction'] = that.$utils.formatNumberWithCommas(transaction)
          view_data['transaction_rate'] = that.$utils.formatNumberWithCommas(transaction_rate)
          view_data['values'] = that.$utils.formatNumberWithCommas(values)
          view_data['values_rate'] = that.$utils.formatNumberWithCommas(values_rate)
        }
        table_items.push(view_data)
      })

      return table_items
    },
    createViewEventMapper: function (datas) {
      let category_data_mapper = {}
      datas.forEach(function (analysis_data) {
        if (category_data_mapper[analysis_data.vid] === undefined) {
          category_data_mapper[analysis_data.vid] = {}
        }
        if (category_data_mapper[analysis_data.vid][analysis_data.event] === undefined) {
          category_data_mapper[analysis_data.vid][analysis_data.event] = {}
        }
        if (category_data_mapper[analysis_data.vid][analysis_data.event][analysis_data.event_date] === undefined) {
          category_data_mapper[analysis_data.vid][analysis_data.event][analysis_data.event_date] = {}
        }
        category_data_mapper[analysis_data.vid][analysis_data.event][analysis_data.event_date] = analysis_data
      })

      return category_data_mapper
    },
    calculateCategorySum(category, category_data_mapper, value_type, specific_vid, specific_day) {
      let total = 0
      if (specific_vid) {
        if (category_data_mapper[specific_vid] && category_data_mapper[specific_vid][category]) {
          if (specific_day) {
            if (
              category_data_mapper[specific_vid][category] &&
              category_data_mapper[specific_vid][category][specific_day]
            ) {
              total += category_data_mapper[specific_vid][category][specific_day][value_type]
            }
          } else {
            let days = Object.keys(category_data_mapper[specific_vid][category])
            days.forEach(function (day) {
              total += category_data_mapper[specific_vid][category][day][value_type]
            })
          }
        }
      } else {
        let vids = Object.keys(category_data_mapper)
        vids.forEach(function (vid) {
          if (category_data_mapper[vid][category]) {
            let days = Object.keys(category_data_mapper[vid][category])
            days.forEach(function (day) {
              total += category_data_mapper[vid][category][day][value_type]
            })
          }
        })
      }

      return total
    },
    createTableDatas(view_items, category_data_mapper) {
      // 建立table的資料
      let table_items = this.handleTableData(view_items, category_data_mapper)
      return table_items
    },
    sumGoalByRange(date_ranges, goal, category_data_mapper, vid) {
      let results = []
      let result = 0
      let that = this
      date_ranges.forEach(function (target_date) {
        switch (goal) {
          case 'View':
            result = that.calculateCategorySum('View', category_data_mapper, 'value_count', vid, target_date)
            break
          case 'AddToCart':
            result = that.calculateCategorySum('AddToCart', category_data_mapper, 'value_count', vid, target_date)
            break
          case 'Transaction':
            result = that.calculateCategorySum('PlaceAnOrder', category_data_mapper, 'value_count', vid, target_date)
            break
          case 'Value':
            result = that.calculateCategorySum('PlaceAnOrder', category_data_mapper, 'value_sum', vid, target_date)
            break
        }
        results.push(result)
      })

      return results
    },
    checkDate: async function () {
      console.log('change_la')

      let start_at = new Date(this.timer_picker.start_at.value).getTime()
      let end_at = new Date(this.timer_picker.end_at.value).getTime()

      if (end_at < start_at) {
        this.timer_picker.error_msg = '結束時間不能早於開始時間'
        return
      }
      this.timer_picker.error_msg = ''
      this.table_loading = true
      try {
        let analysis_data = await this.getReportResult(this.timer_picker.start_at.value, this.timer_picker.end_at.value)
        this.order_event_ids = analysis_data.order_event_ids
        this.analysis_datas = analysis_data.total
        console.log('this.analysis_datas', this.analysis_datas)

        // 這次要顯示的區間資料
        let filter_datas = this.filterDisplayData(
          this.analysis_datas,
          this.timer_picker.start_at.value,
          this.timer_picker.end_at.value
        )
        console.log('filter_datas', filter_datas)

        let category_data_mapper = this.createViewEventMapper(filter_datas)
        console.log('category_data_mapper', category_data_mapper)
        this.category_data_mapper = category_data_mapper

        this.category_table_item['All'] = this.createTableDatas(this.local_items, category_data_mapper)

        console.log('ALLL', this.category_table_item['All'])
        // 總觀看次數
        this.total_view_session = this.calculateCategorySum('View', this.category_data_mapper, 'value_count')
        // 算總和
        // 工作階段總和
        try {
          this.total_row = this.calculateTotalRow(category_data_mapper)
        } catch (error) {
          console.log('total_error', error)
        }

        console.log('add', this.category_table_item['All'])
      } catch (error) {
        console.log('table_error', error)
      }
      this.drag_items = JSON.parse(JSON.stringify(this.category_table_item[this.selected_category.value]))
      this.table_loading = false
      this.renderChart(this.category_data_mapper)
      this.getViewBounceRate(
        this.timer_picker.start_at.value,
        this.timer_picker.end_at.value,
        this.category_table_item['All']
      )
    },
    async getViewBounceRate(start, end) {
      try {
        console.log('b_category_table_item', this.category_table_item['All'])
        let b_result = await apiGetAnalysisReportBounce(
          this.$route.params.org_id,
          this.$route.params.experiment_id,
          start,
          end
        )
        console.log('b_result', b_result)
        let total_view_session = 0
        let total_bounce_event = 0
        this.category_table_item['All'].forEach((row) => {
          console.log('row', row)

          let map_bs = b_result.data.total.filter((item) => {
            return item.vid === row.id
          })
          console.log('map_bs', map_bs)
          let bounce_event = 0
          let session = parseInt(row['session'].toString().replace(/,/g, ''))
          map_bs.forEach((map_b) => {
            bounce_event += map_b.value_count
          })
          console.log('row_bounce_event', bounce_event)
          console.log('row_session', session)
          let bounce_rate = ((bounce_event / session) * 100).toFixed(this.fix_dot)
          if (isNaN(bounce_rate)) {
            bounce_rate = '0.00%'
          } else {
            bounce_rate = bounce_rate.toString() + '%'
          }
          row.bounce_rate = bounce_rate

          total_bounce_event += bounce_event
          total_view_session += session
        })

        let all_bounce_rate = ((total_bounce_event / total_view_session) * 100).toFixed(this.fix_dot)
        if (isNaN(all_bounce_rate)) {
          all_bounce_rate = '0.00%'
        } else {
          all_bounce_rate = all_bounce_rate.toString() + '%'
        }

        this.total_row.bounce_rate = all_bounce_rate
      } catch (error) {
        console.log('c_error', error)
      }
      let exp_add_column = this.selectedExperience.add_column
      console.log('selectedExperience', this.selectedExperience)
      console.log('exp_add_column', exp_add_column)
      // 讀已經存在的排序
      this.drag_items = JSON.parse(JSON.stringify(this.category_table_item[this.selected_category.value]))
      if (exp_add_column) {
        exp_add_column = JSON.parse(exp_add_column)
        if (exp_add_column['exp_report_sort']) {
          this.drag_items = []
          let sort_items = exp_add_column['exp_report_sort']
          sort_items.forEach((sort_item) => {
            if (sort_item.childs && sort_item.childs.length > 0) {
              let child_views = []
              let parent_row = {
                id: sort_item.id,
                name: sort_item.name,
                session: 0,
                dup_session: 0,
                bounce_rate: '0.00%',
                cart: 0,
                dup_cart: 0,
                cart_rate: '0.00%',
                dup_cart_rate: '0.00%',
                transaction: 0,
                transaction_rate: 0,
                values_rate: '0.00%',
                values: 0,
                childs: [],
                is_open: true,
              }
              sort_item.childs.forEach((child) => {
                let view = this.category_table_item[this.selected_category.value].find((item) => {
                  return item.id === child
                })
                if (view) {
                  view = JSON.parse(JSON.stringify(view))
                  view.parent = sort_item.id
                  child_views.push(view)
                }
              })
              parent_row.childs = child_views
              parent_row.is_open = sort_item.is_open
              this.drag_items.push(parent_row)
            } else {
              console.log('cate', this.category_table_item[this.selected_category.value])
              console.log('sort_item',sort_item)
              let view = this.category_table_item[this.selected_category.value].find((item) => {
                return item.id === sort_item.id
              })
              if (view) {
                view = JSON.parse(JSON.stringify(view))
                view.parent = sort_item.parent
                view.is_open = sort_item.is_open
                this.drag_items.push(view)
              }

            }
          })

          // 後來新的版本
          this.category_table_item[this.selected_category.value].forEach((item) => {
            let exist_view = this.drag_items.find((drag_item) => {
              return drag_item.id === item.id
            })
            if (!exist_view) {
              let tmp = JSON.parse(JSON.stringify(item))
              this.drag_items.push(tmp)
            }
          })
        }
      }
      console.log('drag_items', this.drag_items)
    },
    changeDateUnit: function (day_unit) {
      console.log('change_la_day_unit', day_unit)
      let date_ranges = this.createDateUnitByRange(
        this.timer_picker.start_at.value,
        this.timer_picker.end_at.value,
        day_unit
      )
      console.log('date_ranges', date_ranges)
    },
    renderChart: function (category_data_mapper) {
      let that = this
      // 圖表的內容
      let date_ranges = this.createDateUnitByRange(
        this.timer_picker.start_at.value,
        this.timer_picker.end_at.value,
        this.selected_day_unit
      )

      // 先準備好labels
      let labels = []
      date_ranges.forEach(function (date_range) {
        // console.log(typeof date_range)
        if (typeof date_range === 'string') {
          let month = new Date(date_range).getMonth() + 1
          let day = new Date(date_range).getDate()
          labels.push(`${month}-${day}`)
        } else {
          let start_at_month = new Date(date_range[0]).getMonth() + 1
          let start_at_day = new Date(date_range[0]).getDate()

          let end_at_month = new Date(date_range[date_range.length - 1]).getMonth() + 1
          let end_at_day = new Date(date_range[date_range.length - 1]).getDate()

          let label = `${start_at_month}-${start_at_day} ~ ${end_at_month}-${end_at_day}`
          labels.push(label)
        }
      })
      console.log('labels', labels)
      console.log('date_ranges', date_ranges)
      console.log('this.drag_items', this.drag_items)
      this.category_chartdata['labels'] = labels
      that.category_chartdata['datasets'] = []

      let rows = this.drag_items.filter((drag_item) => {
        return drag_item.childs || !drag_item.parent
      })
      console.log('rows', rows)

      rows.forEach((row, idx) => {
        let dataset = {
          vid: row.id,
          label: row.name + `(${that.selected_goal_1.text})`,
          borderColor: this.vid_colors[idx],
          backgroundColor: this.vid_colors[idx],
          data: [],
          type: 'line',
          yAxisID: 'y',
        }
        date_ranges.forEach(function (date_range) {
          let results = []
          let count = 0
          let date_param = ''
          // console.log('type_date_range', typeof date_range)
          if (typeof date_range === 'string') {
            date_param = [date_range]
          } else {
            date_param = JSON.parse(JSON.stringify(date_range))
          }
          // console.log('date_param', date_param)
          if (row.id.includes('parent')) {
            row.childs.forEach((child) => {
              results = that.sumGoalByRange(date_param, that.selected_goal_1.value, category_data_mapper, child.id)
              results.forEach((result) => {
                count += result
              })
            })
          } else if (!row.parent) {
            results = that.sumGoalByRange(date_param, that.selected_goal_1.value, category_data_mapper, row.id)
            results.forEach((result) => {
              count += result
            })
          }

          // console.log('date_range', date_range)
          // console.log('dataset_data', results)
          dataset['data'].push(count)
        })

        that.category_chartdata['datasets'].push(dataset)
      })

      console.log('that.category_chartdata', that.category_chartdata)
      this.table_render_key += 1

      if (
        this.selectedExperience.release === true &&
        this.selectedExperience.enable === true &&
        new Date().getTime() < new Date(this.selectedExperience.end_at).getTime()
      ) {
        this.chartOptions.plugins.pulsingPoint = {
          enabled: true,
          vid_data_mapper: this.vid_data_mapper,
        }
        setTimeout(() => {
          const updateLoop = () => {
            if (this.$refs.lineChart) {
              this.$refs.lineChart.updateChart()
            }
            requestAnimationFrame(updateLoop)
          }
          updateLoop()
        }, 1000)
      }

      // const updateLoop = () => {
      //   if (this.$refs.lineChart) {
      //     this.$refs.lineChart.updateChart()
      //   }
      //   requestAnimationFrame(updateLoop)
      // }

      // updateLoop()
    },
    createDateUnitByRange(start_at, end_at, type) {
      let labels = []
      let weeks = []
      let last_month = null
      let start = new Date(start_at)
      let end = new Date(end_at)
      let now = new Date()
      if (now < start) {
        start = now
      }
      if (now < end) {
        end = now
      }
      const DAY = 24 * 60 * 60 * 1000
      switch (type) {
        case 0:
          for (let d = start; d <= end; d = new Date(d.getTime() + DAY)) {
            labels.push(d.toISOString().split('T')[0])
          }
          break
        case 1:
          for (let d = start; d <= end; d = new Date(d.getTime() + DAY)) {
            weeks.push(d.toISOString().split('T')[0])
            if (d.getDay() === 6) {
              labels.push(weeks)
              weeks = []
              continue
            }
            let next = new Date(d.getTime() + DAY)
            if (next > end) {
              labels.push(weeks)
              break
            }
          }
          break
        case 2:
          for (let d = start; d <= end; d = new Date(d.getTime() + DAY)) {
            if (last_month === null) {
              last_month = d.getMonth()
            }

            if (d.getMonth() !== last_month) {
              last_month = d.getMonth()
              labels.push(weeks)
              weeks = []
            }
            weeks.push(d.toISOString().split('T')[0])
            let next = new Date(d.getTime() + DAY)
            if (next > end) {
              labels.push(weeks)
              break
            }
          }
          break
      }
      return labels
    },
    createColors: function (color_number, base_color, color_step) {
      let generatedColors = []
      for (let i = 0; i < color_number; i++) {
        const r = parseInt(base_color.slice(1, 3), 16) + i * color_step
        const g = parseInt(base_color.slice(3, 5), 16) + i * color_step
        const b = parseInt(base_color.slice(5, 7), 16) + i * color_step

        const hexColor = `#${Math.min(r, 255).toString(16).padStart(2, '0')}${Math.min(g, 255)
          .toString(16)
          .padStart(2, '0')}${Math.min(b, 255).toString(16).padStart(2, '0')}`
        generatedColors.push(hexColor)
      }
      return generatedColors
    },
    generateLabels(start = this.start_at, end = this.end_at) {
      console.log(start)
      let startDate = start ? new Date(start) : new Date(this.selectedExperience.start_at.split(' ')[0])
      const endDate = end ? new Date(end) : new Date(this.selectedExperience.end_at.split(' ')[0])
      let result = []
      while (startDate <= endDate) {
        result.push(this.getformatDateYYYYMMDD(startDate))
        startDate.setDate(startDate.getDate() + 1)
      }
      console.log(result)
      return result
    },
    getformatDateYYYYMMDD(date) {
      let day = date.getDate()
      let month = date.getMonth() + 1
      let year = date.getFullYear()

      if (day < 10) day = '0' + day
      if (month < 10) month = '0' + month

      return year + '-' + month + '-' + day
    },
    async getReportResult(start_at, end_at) {
      let result
      result = await apiGetAnalysisReport(this.$route.params.org_id, this.selectedExperience.id, start_at, end_at)
        .then((resp) => {
          console.log(resp)
          let msg
          if (resp['data']['ok'] === 1) {
            const {
              data: { data, msg: message },
            } = resp
            msg = message
            console.log(data)
            console.log(msg)
            return data
          } else {
            this.$root.vtoast.show({ message: msg, color: 'error' })
            return null
          }
        })
        .catch((error) => {
          console.log(error)
          this.$root.vtoast.show({ message: '取得分析結果錯誤，原因: ' + error.response ? error.response : error })
          return null
        })
      return result
    },
    calculateTotalRow(category_mapper) {
      console.log('category_mapper', category_mapper)

      let total_view_session = this.calculateCategorySum('View', category_mapper, 'value_count')
      console.log('total_view_session', total_view_session)

      let total_dup_view_session = this.calculateCategorySum('View', category_mapper, 'value_count_repeat')

      let total_bounce_event = this.calculateCategorySum('BounceCount', category_mapper, 'value_count')

      // 加入購物車
      let total_addCart_session = this.calculateCategorySum('AddToCart', category_mapper, 'value_count')
      console.log('total_addCart_session', total_addCart_session)

      let total_dup_addCart_session = this.calculateCategorySum('AddToCart', category_mapper, 'value_count_repeat')

      let bounce_rate = ((total_bounce_event / total_view_session) * 100).toFixed(this.fix_dot)
      if (isNaN(bounce_rate)) {
        bounce_rate = '0%'
      } else {
        bounce_rate = '0%'
      }
      // 加入購物車率
      let cart_rate = ((total_addCart_session / total_view_session) * 100).toFixed(this.fix_dot)
      if (isNaN(cart_rate)) {
        cart_rate = '0.00%'
      } else {
        cart_rate = cart_rate.toString() + '%'
      }

      let dup_cart_rate = ((total_dup_addCart_session / total_dup_view_session) * 100).toFixed(this.fix_dot)
      if (isNaN(dup_cart_rate)) {
        dup_cart_rate = '0.00%'
      } else {
        dup_cart_rate = dup_cart_rate.toString() + '%'
      }

      console.log('cart_rate', cart_rate)

      // 下單數
      let total_placeOrder_session = this.calculateCategorySum('PlaceAnOrder', category_mapper, 'value_count')
      console.log('total_placeOrder_session', total_placeOrder_session)

      // 下單率
      let transaction_rate = ((total_placeOrder_session / total_view_session) * 100).toFixed(this.fix_dot)
      if (isNaN(transaction_rate)) {
        transaction_rate = '0.00%'
      } else {
        transaction_rate = transaction_rate.toString() + '%'
      }

      // 營業額
      let values = this.calculateCategorySum('PlaceAnOrder', category_mapper, 'value_sum')

      // 客單價
      let values_rate = (values / total_placeOrder_session).toFixed(this.fix_dot)
      if (isNaN(values_rate)) {
        values_rate = '0.00'
      } else {
        values_rate = values_rate.toString()
      }

      const row = {
        name: '總和',
        session: this.$utils.formatNumberWithCommas(total_view_session),
        dup_session: this.$utils.formatNumberWithCommas(total_dup_view_session),
        cart: this.$utils.formatNumberWithCommas(total_addCart_session),
        dup_cart: this.$utils.formatNumberWithCommas(total_dup_addCart_session),
        bounce_rate: bounce_rate,
        cart_rate: cart_rate,
        dup_cart_rate: dup_cart_rate,
        transaction: total_placeOrder_session,
        transaction_rate: transaction_rate,
        values: this.$utils.formatNumberWithCommas(values),
        values_rate: this.$utils.formatNumberWithCommas(values_rate),
      }
      console.log('total_row', row)

      return row
    },
    viewOrders(item) {
      console.log('item', item)
      console.log('order', this.order_event_ids)

      let that = this
      let target_view_id = item.id
      let dates = Object.keys(this.order_event_ids)
      let orders = {}
      dates.forEach(function (date) {
        let start_at = new Date(that.timer_picker.start_at.value).getTime()
        let end_at = new Date(that.timer_picker.end_at.value).getTime()
        let target_date = new Date(date).getTime()
        if (target_date >= start_at && target_date <= end_at) {
          if (that.order_event_ids[date][target_view_id]) {
            orders[date] = that.order_event_ids[date][target_view_id]
          }
        }
      })

      let event_dates = Object.keys(orders)
      event_dates.forEach(function (event_date) {
        orders[event_date].forEach(function (event) {
          console.log('order_event:', event)
          let content = event.content
          let quantity = 0
          try {
            content = JSON.parse(content)
            quantity = content.contents.length
          } catch (error) {
            console.log('order_event_content_error', error)
          }

          let row = {
            event_date: event_date,
            order_id: event.event_id,
            value: event.value,
            quantity: quantity,
          }
          if (!row.quantity) {
            row.quantity = 'N/A'
          }
          if (!row.value) {
            row.value = 'N/A'
          }

          that.order_dialog.items.push(row)
        })
      })
      let date_items = this.generateLabels(this.timer_picker.start_at.value, this.timer_picker.end_at.value)
      that.order_dialog.start_at_items = date_items
      that.order_dialog.end_at_items = date_items
      this.order_dialog.selected_start_at_item = this.timer_picker.start_at.value
      this.order_dialog.selected_end_at_item = this.timer_picker.end_at.value
      this.order_dialog.view = item
      this.order_dialog.is_show = true
      console.log('this.order_dialog', this.order_dialog)
    },
    hideOrderDialog: function () {
      this.order_dialog.is_show = false
      this.order_dialog.items = []
      this.order_dialog.keyword = ''
      this.order_dialog.view = null
    },
    search: function () {
      let that = this
      let target_view_id = this.order_dialog.view.id
      let dates = Object.keys(this.order_event_ids)
      let orders = {}
      dates.forEach(function (date) {
        let start_at = new Date(that.order_dialog.selected_start_at_item).getTime()
        let end_at = new Date(that.order_dialog.selected_end_at_item).getTime()
        let target_date = new Date(date).getTime()
        if (target_date >= start_at && target_date <= end_at) {
          if (that.order_event_ids[date][target_view_id]) {
            orders[date] = that.order_event_ids[date][target_view_id]
          }
        }
      })
      this.order_dialog.items = []
      let event_dates = Object.keys(orders)
      event_dates.forEach(function (event_date) {
        orders[event_date].forEach(function (event) {
          console.log('event', event)
          let contents = []
          if (event.content) {
            try {
              let content = JSON.parse(event.content)
              contents = content.contents
            } catch (error) {
              contents = []
            }
          }
          let row = {
            event_date: event_date,
            order_id: event.event_id,
            quantity: contents.length ? contents.length : '--',
            value: event.value,
          }

          if (that.order_dialog.keyword.includes(',')) {
            let keyword = that.order_dialog.keyword.replace(/ /g, '')
            let ids = keyword.split(',')
            console.log('ids', ids)
            console.log(ids.includes(keyword))
            console.log('keyword', keyword)
            console.log(ids.includes(event))
            if (ids.includes(event)) {
              that.order_dialog.items.push(row)
            }
          } else if (that.order_dialog.keyword) {
            if (event.includes(that.order_dialog.keyword)) {
              that.order_dialog.items.push(row)
            }
          } else {
            that.order_dialog.items.push(row)
          }
        })
      })

      console.log('this.order_dialog.items', this.order_dialog.items)
    },
    async previewVersion(item) {
      console.log(item)
      console.log('apiGetPreviewTokenWithData', apiGetPreviewTokenWithData)
      try {
        let result = await apiGetPreviewTokenWithData(this.$route.params.org_id, item.id)
        let token = result.token
        console.log(token)
        let url = new URL(decodeURIComponent(this.selectedExperience.url))
        url.searchParams.append('opt99_auth_token', token)
        url.searchParams.append('opt99_preview', item.id)

        let organize = this.organize_container_mapper[this.$route.params.org_id]
        let current_container = organize.containers.find((container) => {
          return container.id === this.$route.params.container_id
        })

        let connect_id = current_container.cyberbiz_info
          ? current_container.cyberbiz_info.cb_shop_id.toString()
          : this.$route.params.container_id

        url.searchParams.append('opt99_c_id', connect_id)

        url.searchParams.append('opt99_c_id', this.$route.params.container_id)

        window.open(url.href, '_blank').focus()
      } catch (error) {
        this.$root.vtoast.show({
          message: '預覽失敗，原因: ' + (error.response ? JSON.stringify(error.response) : error),
        })
      }
    },
    goGoogleAnalytics() {
      let that = this
      console.log(this.selectedContainer)
      console.log(this.organize_container_mapper)
      let now_container = this.organize_container_mapper[this.$route.params.org_id].containers.filter(function (
        container
      ) {
        return container.id === that.$route.params.container_id
      })
      if (now_container[0].add_column === null) {
        this.hint_dialog.title = '系統訊息'
        this.hint_dialog.html = `
                    <p class="mb-0">尚未設定容器的Google Analytics編號</p>
                    <p class="mb-0">請點選下方 "前往設定" 進行設定</p>
                `
        this.hint_dialog.action_text = '前往設定'
        sessionStorage.setItem('selected_container', JSON.stringify(this.selectedContainer))
        this.hint_dialog.action_method_params = {
          method: 'goPage',
          url: `/${this.$route.params.org_id}/setting/containers/${this.$route.params.container_id}/edit`,
        }
        this.hint_dialog.is_show = true
        return
      }

      let add_column = JSON.parse(now_container[0].add_column)
      console.log('add_column ', add_column)
      let ga_id = add_column['optimize']['experiment']['ga_id'].value
      console.log('ga_id', ga_id)
      window.open(`https://analytics.google.com/analytics/web/#/p${ga_id}/reports/reportinghub`, '_blank')
    },
    hideHintDialog() {
      this.hint_dialog.is_show = false
    },
    hintAction(action_method_params) {
      switch (action_method_params.method) {
        case 'goPage':
          this.$router.push(action_method_params.url)
      }
    },
    async stopExperiment() {
      let id = this.$route.params.experiment_id
      let confirm_dialog = confirm(`請問您確定結束實驗嗎? 結束後無法再更改此實驗！`)
      if (!confirm_dialog) {
        return
      }
      console.log('結束實驗')
      await apiPatchExperienceDisable(id, this.$route.params.org_id)
        .then((resp) => {
          console.log('結束實驗成功', resp)
          this.$root.vtoast.show({ message: '結束實驗成功!', color: 'primary' })
          this.$router.go()
        })
        .catch((error) => {
          console.log('結束實驗失敗', error)
          this.$root.vtoast.show({
            message: '結束實驗失敗，原因: ' + (error.response ? JSON.stringify(error.response.data) : error),
          })
        })
    },
    parseDisplayTime(datetime_string) {
      let date_string = datetime_string.split(' ')[0]
      let times = datetime_string.split(' ')[1].split(':')
      let time_string = `${times[0]}:${times[1]}`
      let result = `${date_string} ${time_string}`
      return result
    },
    goQA(link_poniter) {
      window.open(`${this.info_url}${link_poniter}`, '_blank')
    },
    showScreenshot(url) {
      window.open(`${url}`, '_blank')
    },
    onMove(evt) {
      let releated_row = evt.relatedContext.element
      let current_row = evt.draggedContext.element

      // 當前列如果是母列
      if (current_row.childs && current_row.childs.length > 0) {
        if (releated_row.parent) {
          return false
        } else {
          return true
        }
      }

      // 如果當前列是子列
      if (current_row.parent) {
        if (!releated_row.parent || releated_row.parent !== current_row.parent) {
          return false
        } else {
          return true
        }
      } else {
        if (releated_row.parent) {
          return false
        }
      }
    },
    onDragEnd(evt) {
      console.log('drag_items_onDragEnd', JSON.stringify(this.drag_items))
      console.log('drag_env', evt)
      console.log('drag_end', this.drag_items)
      let new_items = []
      for (let idx = 0; idx < this.drag_items.length; idx++) {
        // console.log('now', this.drag_items[idx])
        if (!this.drag_items[idx].parent && !this.drag_items[idx].childs) {
          new_items.push(this.drag_items[idx])
          continue
        }

        if (this.drag_items[idx].resorted) {
          continue
        }

        if (this.drag_items[idx].id.includes('parent')) {
          new_items.push(this.drag_items[idx])
          let childs = this.drag_items.filter((drag_item) => {
            // console.log('find_parent', drag_item.parent === this.drag_items[idx].id)
            return drag_item.parent === this.drag_items[idx].id
          })
          // console.log('childssss', childs)
          childs.forEach((child) => {
            child.resorted = true
            new_items.push(child)
          })
        }
      }
      // console.log('real_new_items_hehe', new_items)
      this.drag_items = JSON.parse(JSON.stringify(new_items))
      this.table_key += 1
      // console.log('new_items_hehe', this.drag_items)
    },
    createGroup() {
      let is_valid = true
      let parent_count = 0
      let parent_row = null
      for (let idx = 0; idx < this.selected_views.length; idx++) {
        let view = this.drag_items.find((item) => {
          return item.id === this.selected_views[idx]
        })
        if (view.childs && view.childs.length > 0) {
          parent_row = view
          parent_count += 1
        }
        if (parent_count > 1) {
          is_valid = false
          break
        }
        if (view.parent) {
          is_valid = false
          break
        }
      }
      if (!is_valid) {
        this.$root.vtoast.show({
          message: `勾選的選項有群組或是已經在群組內，不能再合併。`,
        })
        return
      }

      console.log('this.group_setting', this.group_setting)
      if (parent_count > 0) {
        let params = {
          fields: [
            {
              key: 'name',
              value: parent_row.name,
            },
          ],
        }
        this.getGroupName(params)
      } else {
        this.group_setting.is_show = true
      }
    },
    cancelCreateGroup() {
      this.group_setting.is_show = false
      this.group_setting.fields.forEach((field) => {
        field.value = ''
      })
    },
    getGroupName(params) {
      console.log('params', params)
      let name_field = params.fields.find((field) => {
        return field.key === 'name'
      })
      let parent_id = `parent-${new Date().getTime()}`
      let parent_row = {
        id: parent_id,
        name: name_field.value,
        session: 0,
        dup_session: 0,
        bounce_rate: '0.00%',
        cart: 0,
        dup_cart: 0,
        cart_rate: '0.00%',
        dup_cart_rate: '0.00%',
        transaction: 0,
        transaction_rate: 0,
        values_rate: '0.00%',
        values: 0,
        childs: [],
        is_open: true,
      }

      for (let idx = 0; idx < this.selected_views.length; idx++) {
        let view_id = this.selected_views[idx]
        let view = this.drag_items.find((item) => {
          return item.id === view_id
        })

        if (view.childs && view.childs.length > 0) {
          parent_row = JSON.parse(JSON.stringify(view))
          console.log('有parent')
          break
        }
      }
      console.log('parent_row', parent_row)
      this.selected_views.forEach((selected_view) => {
        let view = this.drag_items.find((view) => {
          return view.id === selected_view && !view.id.includes('parent')
        })
        if (view) {
          view.parent = parent_row.id
          parent_row.childs.push(view)
        }
      })

      let new_items = []
      let exist_parents = this.drag_items.filter((row) => {
        return row.id.includes('parent') && row.id !== parent_row.id
      })
      console.log('exist_parents', exist_parents)
      let un_groups = this.drag_items.filter((row) => {
        return !row['parent'] && !row.childs
      })
      exist_parents.forEach((exist_parent) => {
        new_items.push(exist_parent)
        exist_parent.childs.forEach((child) => {
          new_items.push(child)
        })
      })
      new_items.push(parent_row)
      parent_row.childs.forEach((child) => {
        new_items.push(child)
      })
      un_groups.forEach((view) => {
        let idx = this.drag_items.findIndex((item) => {
          return item.id === view.id
        })
        console.log('un_group_index', idx)
        new_items.push(view)
      })

      // this.category_table_item[this.selected_category.value] = JSON.parse(JSON.stringify(new_items))
      this.drag_items = JSON.parse(JSON.stringify(new_items))
      this.table_key += 1
      this.selected_views = []
      this.cancelCreateGroup()

      // 重畫圖表
      this.renderChart(this.category_data_mapper)

      console.log('merge_new_items', this.drag_items)
    },
    unMergeRow() {
      this.selected_views.forEach((selected_view) => {
        let view = this.drag_items.find((item) => {
          return item.id === selected_view
        })
        let view_idx = this.drag_items.findIndex((item) => {
          return item.id === selected_view
        })

        // subrow解除的情境
        if (view.parent) {
          let parent_row = this.drag_items.find((item) => {
            return item.id === view.parent
          })
          parent_row.childs = parent_row.childs.filter((child) => {
            return child.id !== view.id
          })
          view.parent = ''
          this.drag_items.splice(view_idx, 1)
          this.drag_items.push(view)

          if (parent_row.childs.length === 0) {
            // 移除row
            let view_idx = this.drag_items.findIndex((item) => {
              return item.id === parent_row.id
            })
            this.drag_items.splice(view_idx, 1)
          }
        }

        // 是parent解除的狀況
        if (view.childs) {
          view.childs.forEach((child) => {
            let real_child = this.drag_items.find((item) => {
              return item.id === child.id
            })
            real_child.parent = ''
            real_child.is_open = true
          })
          // 移除row
          let view_idx = this.drag_items.findIndex((item) => {
            return item.id === selected_view
          })
          this.drag_items.splice(view_idx, 1)
        }
      })
      this.table_key += 1
      this.selected_views = []
      // 重畫圖表
      this.renderChart(this.category_data_mapper)
    },
    calculateSum(current_row, childs, sum_key) {
      let count = current_row[sum_key]
      if (typeof count === 'string') {
        count = count.replace(/,/g, '')
        count = parseInt(count)
      }
      if (childs) {
        childs.forEach((child) => {
          if (typeof child[sum_key] === 'string') {
            child[sum_key] = child[sum_key].replace(/,/g, '')
            child[sum_key] = parseInt(child[sum_key])
          }
          count += child[sum_key]
        })
      }
      return count
    },
    calculateRateSum(current_row, childs, sum_key) {
      let count = current_row[sum_key]
      if (typeof count === 'string' && count.includes('%')) {
        count = count.replace('%', '')
      }
      count = parseFloat(count)
      if (childs) {
        childs.forEach((child) => {
          let tmp = child[sum_key]
          if (typeof tmp === 'string' && tmp.includes('%')) {
            tmp = tmp.replace('%', '')
          }
          tmp = parseFloat(tmp)
          count += tmp
        })
      }
      let child_num = childs ? childs.length : 0
      let total_item = child_num ? child_num : 1
      count = (count / total_item).toFixed(this.fix_dot)
      if (!isFinite(count) || isNaN(count)) {
        count = 0
      }
      count = `${count}%`
      return count
    },
    resetGroup() {
      console.log('drag_items', this.drag_items)
      this.drag_items = JSON.parse(JSON.stringify(this.category_table_item[this.selected_category.value]))
      this.table_key += 1
    },
    async saveGroup() {
      console.log('drag_items', this.drag_items)
      let sort_items = this.drag_items.map((drag_item) => {
        if (drag_item.childs) {
          let child_ids = drag_item.childs.map((child) => {
            return child.id
          })
          return {
            id: drag_item.id,
            name: drag_item.name,
            is_open: drag_item.is_open,
            childs: child_ids,
          }
        } else {
          return {
            id: drag_item.id,
            name: drag_item.name,
            is_open: drag_item.is_open,
            parent: drag_item.parent ? drag_item.parent : '',
          }
        }
      })
      console.log('sort_items', JSON.stringify(sort_items))
      let exp_add_column = this.selectedExperience.add_column
      if (exp_add_column) {
        exp_add_column = JSON.parse(exp_add_column)
      } else {
        exp_add_column = {}
      }
      try {
        exp_add_column['exp_report_sort'] = sort_items
        let params = {
          add_column: JSON.stringify(exp_add_column),
        }
        let result = await apiRenameExp(this.$route.params.org_id, this.$route.params.experiment_id, params)
        console.log('save_result', result)
        this.$root.vtoast.show({
          message: `保存排序成功!`,
          color: 'primary',
        })
      } catch (error) {
        this.$root.vtoast.show({
          message: `保存排序失敗，原因: ${error}`,
        })
      }
    },
    activateSub(item, is_open) {
      item.is_open = is_open
      item.childs.forEach((child) => {
        let view = this.drag_items.find((drag_item) => {
          return drag_item.id === child.id
        })
        view.is_open = is_open
      })
    },
  },
}
</script>

<style scoped>
.icon {
  font-size: 90px;
  height: 128px;
  width: 128px;
  min-height: 128px;
  min-width: 128px;
  border: solid 1px rgb(169, 164, 164);
  border-radius: 50%;
}

.text {
  text-align: center;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.date-picker {
  width: 120px !important;
}
.time-picker-error-msg {
  color: red;
  font-size: 14px;
}
.goal-selector {
  min-width: 5em;
  max-width: 10em;
}
/*.experiment_status.running {
  background: #1c73e8;
  color: #fff;
}
.experiment_status.end {
  background: #33a853;
  color: #fff;
}
.experiment_time.running {
  background-color: #165abc;
}
.experiment_time.end {
  background-color: #137333;
}*/
.parent-row {
  font-weight: bold;
}
.sub-row {
  padding-left: 30px !important;
}
.no-break-line {
  white-space: nowrap;
}
.drag-handle {
  cursor: pointer;
}
.limit-up {
  color: #ffffff;
  background: #ff3838;
  white-space: nowrap;
}
</style>
